export const GA_TRACKING_ID = "G-YCLDJ3RLP5";
export const GADS_TRACKING_ID = "17858567356";

/** Google Ads conversion labels — verify in Ads > Goals > Conversions > Tag setup */
export const CONVERSION_LABELS = {
    /** "Submit lead form | Owest" */
    LEAD_FORM: "PVmaCLOgjN8bELy50MNC",
    /** Buy now / CTA clicks */
    BUY_NOW: "s22iCL--jN8bELy50MNC",
};

export const grantAdsConsent = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("consent", "update", {
            ad_storage: "granted",
            ad_user_data: "granted",
            ad_personalization: "granted",
        });
    }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("config", GA_TRACKING_ID, {
            page_path: url,
        });
        window.gtag("config", `AW-${GADS_TRACKING_ID}`, {
            page_path: url,
        });
    }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = (action, { category, label, value }) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};

export const conversion = (label) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        grantAdsConsent();
        window.gtag("event", "conversion", {
            send_to: `AW-${GADS_TRACKING_ID}/${label}`,
            transport_type: "beacon",
        });
    }
};
